import { render, staticRenderFns } from "./homeworks.vue?vue&type=template&id=3a11fa55&"
import script from "./homeworks.vue?vue&type=script&lang=js&"
export * from "./homeworks.vue?vue&type=script&lang=js&"
import style0 from "./homeworks.vue?vue&type=style&index=0&id=3a11fa55&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports